export default __webpack_public_path__ + "0c96f78c47f8899f26af7023f8f2f53f.svg";